import { PlatformPage } from './PlatformPage'
import { TenantsTab } from './tabs/TenantsTab'

export function TenantsPage() {
  return (
    <PlatformPage
      title="Customer Tenants"
      description="Manage customer workspaces - plan, user limits, suspend/restore, delete."
    >
      <TenantsTab />
    </PlatformPage>
  )
}
